export class ProgramaRelatorioCnaiCnpc {
    nome: string;

    constructor(nome: string) {
        this.nome = nome;
    }
}


// WEBPACK FOOTER //
// ./src/app/entity/relatorio-programas-cnai-cnpc.ts